import Router from "next/router";
import * as routes from "@/utils/routes";

const handleAuthorizationCheck = (showErrorMessage = false): boolean => {
  const activeRoute = Object.values(routes).find(
    (item) => Router.pathname.split("/")[1] === item.path.replace("/", "")
  );

  const authority = activeRoute?.getAuthorization(true);

  if (!authority?.write) {
    if (showErrorMessage) {
      // handleErrorMessages({ message: "common:errorMessages.notAuthorized" });
    }

    return false;
  }

  return true;
};

export default handleAuthorizationCheck;
